import React, { useEffect, useMemo, useState } from "react";
import LeaveProcessService from "../services/LeaveProcessService";
import LeaveModal from "../components/modals/LeaveModel";
import ARModal from "../components/modals/ARModal";
import ODModal from "../components/modals/ODModal";

export default function LeaveApproval() {

    const [leaves, setLeaves] = useState([]);
    const [statusFilter, setStatusFilter] = useState("");
    const [employeeFilter, setEmployeeFilter] = useState("");

    const [selectedItem, setSelectedItem] = useState(null);
    const [modalType, setModalType] = useState("");

    const [activeTab, setActiveTab] = useState(""); // LEAVE / AR / OD
    const [leaveCount, setLeaveCount] = useState(0);
    const [arCount, setArCount] = useState(0);
    const [odCount, setOdCount] = useState(0);
    const employeeCode = localStorage.getItem("empcode");
    // Month Year Dropdown
    const monthYearList = useMemo(() => {

        const months = [];
        const currentDate = new Date();

        for (let i = 0; i < 12; i++) {

            const date = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth() - i,
                1
            );

            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();

            months.push({
                value: `${month}${year}`,
                label:
                    `${date.toLocaleString("default", {
                        month: "long"
                    })} ${year}`
            });
        }

        return months;

    }, []);



    const formatMonthYearValue = (date) => {

        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        return `${month}${year}`;
    };


    // Default Current Month
    const [monthFilter, setMonthFilter] = useState(
        formatMonthYearValue(new Date())
    );

    useEffect(() => {
        fetchLeaves(""); // only for count
    }, []);
    // ✅ FETCH DATA
    const fetchLeaves = async (type = "") => {
        try {
            const formData = new FormData();
            formData.append("Type", "LeaveForManager");
            formData.append("ManagerCode", employeeCode);
            if (monthFilter) {
                formData.append(
                    "LeaveMMYY",
                    monthFilter
                );
            }
            if (statusFilter) formData.append("Status", statusFilter);
            if (employeeFilter) formData.append("EmployeeCode", employeeFilter);

            const response = await LeaveProcessService.getEmployeeLeaveStatus(formData);

            if (response?.data?.statusCode === 200) {

                let data = response.data.result || [];

                // ✅ COUNT CALCULATION
                const ar = data.filter(x => x.leaveCode === "AR");
                const od = data.filter(x => x.leaveCode === "OD");
                const leave = data.filter(x => x.leaveCode !== "AR" && x.leaveCode !== "OD");

                setArCount(ar.length);
                setOdCount(od.length);
                setLeaveCount(leave.length);

                // ❗ DO NOT SET TABLE DATA ON INITIAL LOAD
                if (!type) {
                    setLeaves([]);
                    return;
                }

                // ✅ TAB FILTER
                if (type === "AR") {
                    data = ar;
                } else if (type === "OD") {
                    data = od;
                } else if (type === "LEAVE") {
                    data = leave;
                }

                setLeaves(data);
            }
        } catch (error) {
            console.error(error);
            setLeaves([]);
        }
    };

    // ✅ TAB CLICK
    const handleTabClick = (type) => {
        setActiveTab(type);
        fetchLeaves(type);
    };

    // ✅ VIEW MODAL
    const handleView = (item) => {
        setSelectedItem(item);

        if (item.leaveCode === "AR") setModalType("AR");
        else if (item.leaveCode === "OD") setModalType("OD");
        else setModalType("LEAVE");
    };

    // ✅ APPROVE / REJECT
    const handleAction = async (leaveAppID, action, remark) => {

        const confirmMsg =
            action === "APPROVE"
                ? "Approve this request?"
                : "Reject this request?";

        if (!window.confirm(confirmMsg)) return;

        try {
            const formData = new FormData();
            formData.append("Type", action);
            formData.append("LeaveAppID", leaveAppID);
            formData.append("ManagerCode", employeeCode);
            formData.append("Reason", remark || "");

            const response = await LeaveProcessService.getEmployeeLeaveStatus(formData);

            if (response?.data?.statusCode === 200) {
                alert("Action completed successfully");
                setModalType("");
                fetchLeaves(activeTab); // reload current tab
            }

            else {
                const message = response.errorMessage || 'Submission failed. Please try again.';
                alert(message);
            }
        } catch (error) {
            const message = error?.message || 'Unexpected error occurred.';
            alert(message);
            console.error("Unhandled error:", message);
        } finally {
            //setLoading(false);
        }
    };

    return (
        <>
            <div className="container-fluid mt-3">

                <h4 className="mb-3">Leave Approval</h4>

                {/* ✅ TABS */}
                <div className="mb-3 d-flex gap-2">

                    <button
                        className={`btn ${activeTab === "LEAVE" ? "btn-primary" : "btn-outline-primary"}`}
                        onClick={() => handleTabClick("LEAVE")}

                    >
                        Leave ({leaveCount})
                    </button>

                    <button
                        className={`btn ${activeTab === "AR" ? "btn-primary" : "btn-outline-primary"}`}
                        onClick={() => handleTabClick("AR")}

                    >
                        AR ({arCount})
                    </button>

                    <button
                        className={`btn ${activeTab === "OD" ? "btn-primary" : "btn-outline-primary"}`}
                        onClick={() => handleTabClick("OD")}

                    >
                        OD ({odCount})
                    </button>

                </div>

                {/* ✅ FILTER */}
                <div className="row mb-3">

                    <div className="col-md-3">
                        <select

                            className="form-select"

                            value={monthFilter}

                            onChange={
                                (e) =>
                                    setMonthFilter(
                                        e.target.value
                                    )
                            }

                        >

                            <option value="">
                                Select Month
                            </option>


                            {
                                monthYearList.map(
                                    (month) => (

                                        <option

                                            key={month.value}

                                            value={month.value}

                                        >

                                            {month.label}

                                        </option>

                                    )
                                )
                            }


                        </select>
                    </div>


                    <div className="col-md-3">
                        <input
                            className="form-control"
                            placeholder="Employee Code"
                            value={employeeFilter}
                            onChange={(e) => setEmployeeFilter(e.target.value)}
                        />
                    </div>

                    <div className="col-md-3">
                        <select
                            className="form-select"
                            value={statusFilter}
                            onChange={(e) => setStatusFilter(e.target.value)}
                        >
                            <option value="">All Status</option>
                            <option value="Pending">Pending</option>
                            <option value="Approved">Approved</option>
                            <option value="Rejected">Rejected</option>
                        </select>
                    </div>

                    <div className="col-md-3">
                        <button
                            className="btn btn-primary w-100"
                            onClick={() => fetchLeaves(activeTab)}
                        >
                            Filter
                        </button>
                    </div>
                </div>

                {/* ✅ TABLE */}
                <div className="card shadow-sm border-0">
                    <div className="card-body p-0">

                        <div style={{ maxHeight: "500px", overflowY: "auto" }}>

                            <table className="table table-hover align-middle text-center mb-0">

                                <thead className="table-dark"
                                    style={{ position: "sticky", top: 0, zIndex: 2 }}>
                                    <tr>
                                        <th>Emp Code</th>
                                        <th>Name</th>
                                        <th>Type</th>
                                        <th>From</th>
                                        <th>To</th>
                                        <th>Total Days</th>
                                        <th>ManagerName</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {activeTab === "" ? (
                                        <tr>
                                            <td colSpan="8">Please select a tab</td>
                                        </tr>
                                    ) : leaves.length > 0 ? (
                                        leaves.map((item) => (
                                            <tr key={item.leaveAppID}>

                                                <td>{item.employeeCode}</td>
                                                <td>{item.employeeName}</td>

                                                <td>
                                                    <span className="badge bg-primary">
                                                        {item.leaveCode}
                                                    </span>
                                                </td>

                                                <td>{new Date(item.fromDate).toLocaleDateString()}</td>
                                                <td>{new Date(item.toDate).toLocaleDateString()}</td>

                                                <td>{item.totalDays}</td>
                                                <td>{item.managerName}</td>
                                                <td>
                                                    <span className={`badge ${item.status === "Approved"
                                                        ? "bg-success"
                                                        : item.status === "Rejected"
                                                            ? "bg-danger"
                                                            : "bg-warning text-dark"
                                                        }`}>
                                                        {item.status}
                                                    </span>
                                                </td>

                                                <td>
                                                    <button
                                                        className="btn btn-info btn-sm"
                                                        onClick={() => handleView(item)}
                                                    >
                                                        View
                                                    </button>
                                                </td>

                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="8">No Data Found</td>
                                        </tr>
                                    )}
                                </tbody>

                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {/* ✅ MODALS */}
            <LeaveModal
                show={modalType === "LEAVE"}
                data={selectedItem}
                onClose={() => setModalType("")}
                isManager={true}
                onAction={handleAction}
            />

            <ARModal
                show={modalType === "AR"}
                data={selectedItem}
                onClose={() => setModalType("")}
                isManager={true}
                onAction={handleAction}
            />

            <ODModal
                show={modalType === "OD"}
                data={selectedItem}
                onClose={() => setModalType("")}
                isManager={true}
                onAction={handleAction}
            />
        </>
    );
}